import styled from 'styled-components';

import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

/**
 * Full-bleed loading surface over a device screen: a single opaque, solid brand fill
 * (no gradient, so it never flickers on a device switch), cross-fading out as the
 * iframe fades in.
 */
export const Fill = styled.div<{ $shown: boolean; $bg?: string }>`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bg }) => $bg ?? CUST.deviceFallbackBg};
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${CUST_ANIM.OVERLAY_MS}ms ease;
  pointer-events: none;
`;

/** Animated Whitelabels.com loader (the app boot spinner), 64x64, fading in/out. */
export const Spinner = styled.img<{ $shown: boolean }>`
  position: relative;
  z-index: 1;
  width: 64px;
  height: 64px;
  display: block;
  object-fit: contain;
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${CUST_ANIM.OVERLAY_MS}ms ease;
`;
